export default "__VITE_ASSET__1a3e3fbf__"